// extracted by mini-css-extract-plugin
export default {"content":"styles_content__9vijW","searchSection":"styles_searchSection__O5l48"};